import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { fetchDataError, fetchDataSuccess } from './actions'
import { DATA_REQUEST } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DATA_REQUEST.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .getUserReportData(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.userId
        )
        .pipe(
          map((response) => fetchDataSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
          takeUntil(action$.pipe(ofType(DATA_REQUEST.CANCEL)))
        )
    )
  )

export default combineEpics(fetchDataEpic)
